export default "__VITE_ASSET__6db76270__"